// extracted by mini-css-extract-plugin
export default {"feedbackMessagesWrapper":"FeedbackMessages_feedbackMessagesWrapper__Ovm6W","feedbackToast":"FeedbackMessages_feedbackToast__XGWUn"};